// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"FavouritesUiDynamicBuyerInfoModal":"639c7dd0","auroraAdobeDmpJs":"5f747881","SmartBannerFullScreen":"339486a0"}[chunkId] + ".js";
};